<template>
  <div class="inventory-check">
    <div class="patient_list">
        <div class="checkin-btn">
          <van-button type="primary" round color="#0AA8AF" @click="addRecord()" block>新增盘点</van-button>
        </div>

        <van-list v-model="loading" :finished="finished" @load="onLoad" >
            <van-cell-group inset class="cell-group" v-for="item,index in list" :key="index">
                <van-cell  :border="false">
                    <template #title><div class="grey_label">省份城市:</div></template>
                    <div>{{item.province}}{{item.city}}</div>
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">药房名称:</div></template>
                    <div>{{item.drugstore_name}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">盘点日期:</div></template>
                    <div>{{item.take_date}}</div>
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">药品名称:</div></template>
                    <div>{{drug}}</div>
                </van-cell>
                <van-cell title="" class="align-right" is-link value="查看详情" @click="showDetail(item)"/>
            </van-cell-group>

            <template #finished>
                <van-divider :style="{ color: '#bababa', borderColor: '#bababa', padding: '0 80px'}">
                    <div style="width:3px;height:3px;border-radius:100%;background-color:#bababa;"></div>
                </van-divider>
            </template>
        </van-list>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List } from 'vant';
import { Divider } from 'vant';
import { mapState } from 'vuex';
import { getDrugstoreTakeList,getDrug } from '@/api/publicWelfareStaff';
// import { mapMutations } from "vuex";
Vue.use(Divider);
Vue.use(List);
export default {
    data(){
        return {
          searchValue: '',
            
            //无限加载列表
            list: [],
            loading: false,
            finished: false,

            page:1,
            drug:''
        }
    },
    computed: {
      ...mapState(['publicWelfareStaff'])
    },
  created() {
      console.log("publicWelfareStaff",this.publicWelfareStaff)
    },
    methods: {
      //   ...mapMutations(['setOriginRoute']),
      async fetchData(page) {
        let DATA
        let sendData = {
          page: page,
          volunteer_id:this.publicWelfareStaff.checkin_info.papid,
        }
        await getDrugstoreTakeList(sendData).then(res => {
          if(res.data){
            console.log("库存盘点列表：",res)
            this.list=[...this.list,...res.data]
            DATA = res.data
          }
        }).catch(err => {
          Toast(err.response.data.message)
        })
        await getDrug().then(res => {
          if(res.data){
            console.log("药品:",res.data)
            this.drug=res.data[1]
          }

        }).catch(err => {
          Toast(err.response.data.message)
        })
        return DATA
      },
      async onLoad() {
        // 异步更新数据        
            await this.fetchData(this.page).then(res => {
              console.log("fetchData",res)
              if (res.length>0) this.page++

              // 加载状态结束
              this.loading = false;

              // 数据全部加载完成
              if (res.length==0) {
                  this.finished = true;
              }
            })
      },
      showDetail(item){
        this.$router.push({name:'inventoryDetail',query:{
            drugstore_take_id:item.id
        }})
      },
      addRecord(item){
        // 新增/修改记录
        // console.log(item?"修改记录":"新增记录")
        // const title=item?"更新患者服务":"新增患者服务"

        this.$router.push({name:'addInventory',query:{
            // 'title':title
            }})
      }
    }
}
</script>

<style lang="scss" scoped>
.inventory-check{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    font-size: 16px;
    ::v-deep .grey_label{
        color:#9D9D9D;
        white-space:nowrap;
    }
    .van-search{
        padding:16px;
    }
    .van-cell-group {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .patient_list{
    //   box-shadow: 0 -2px 6px rgba(73, 46, 46, 0.2);
      padding-bottom: 44px;
        .checkin-btn {
            padding: 25px;
        }
        .cell-group{
            margin-bottom:10px;
            .align-right .van-cell__value{
                    text-align: right;
            }
            
            .van-cell__title {
                flex: 1;
                text-align: right;
                margin-right: 10px;
            }
            .van-cell__value{
                flex: 3;
                color:#0A0A0A;
                // white-space:nowrap;
                text-align: left;
                // display:flex;
                // justify-content:flex-start;
                // align-items:center;
                .alignment-flex{
                    display:flex;
                    justify-content:flex-start;
                    align-items:flex-start;
                }
            }
        }
      
    }
}
</style>